import React, { ReactNode } from 'react';
import { PacotesListContext } from './index';

interface PacotesListProviderProps {
  data: PacoteDataType;
  children?: ReactNode;
}
const PacotesListProvider = ({ data, children }: PacotesListProviderProps) => {
  return <PacotesListContext.Provider value={{ data }}>{children}</PacotesListContext.Provider>;
};

export default PacotesListProvider;
